import React, { Component } from 'react';
import { CheckBox } from '../common/forms';
import { LabelWithArrow, Load } from '../common/basic';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Radio } from 'react-bootstrap';
import dateHelper from '../../helpers/date';
import enums from '../../config/enums';


module.exports = class PatientSmallTitle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            Name: ""
        }
    }


    componentDidMount() {
        this
            ._loading
            .Show();

        axios
            .get("/data/getPatientDetails/" + this.props.patientID)
            .then(function (data) {
                var userData = data.data[0];
                this
                    ._loading
                    .Hide();

                var initial;
                if (userData.Gender == "Male") {
                    initial = "Mr. ";
                } else {
                    initial = "Mrs. ";
                }
                this.setState({
                    Name: initial + userData.FirstName + ' ' + userData.LastName
                });

            }.bind(this))
            .catch(function (error) {
                if (error.response && error.response.data == "No permissions") {
                    window.location.replace("/login");
                }
                console.log(error);
            });
    }

    render() {
        return (
            <div className='patientSmallTitle'>
                <div className='container'>
                    <Load
                        ref={(loading) => {
                            this._loading = loading;
                        }} />
                    <div className='float-left'>
                        <img src={this.props.imgUrl} />
                    </div>
                    <div className='float-left name-title'>
                        <h4>Patient</h4>
                        <div className='name'>{this.state.Name}</div>
                    </div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./modules/doctorAdvice/PatientSmallTitle.jsx